<template>
  <div style="width: 100%; overflow-x: auto">
    <table class="my-table" v-if="periods">
      <thead>
        <tr>
          <th rowspan="2" style="min-width: 400px;">Сотрудник</th>
          <th v-for="month in calendar.months" :key="month" :colspan="month.length">
            <div class="is-uppercase">{{ month.year }} {{ month.name }}</div>
          </th>
        </tr>
        <tr>
          <template v-for="month in calendar.months" :key="month">
            <th v-for="n in parseInt(month.length)" :key="n">
              <div class="calendar-date-cell">
                {{ n }}
              </div>
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
      <template v-for="district in periods" :key="district">
        <tr :colspan="calendar.period.length+1" class="font-weight-bold">{{ district.district_name }}</tr>
        <tr v-for="human in district.users" :key="human" v-on:mouseenter="selectRow()" v-on:mouseleave="deselectRow()">
          <td style="font-size: 12px; cursor: pointer" v-on:click="toggle_drawer(human)">
            {{ human.user_name }}
          </td>
          <template v-for="month in calendar.months" :key="month">
            <th v-for="n in parseInt(month.length)" :key="n">
              <DayCell :periods="periods" :district="district.district_guid" :human="human.user_guid" :day="n" :month="month.id" :year="month.year" />
            </th>
          </template>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Current, Deletion } from "@/store/planner/ToolsStore";
import { CurrentPeriod, PeriodSize } from "@/store/planner/CurrentPeriodStore";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import moment from "moment";
import DayCell from "@/components/Planner/Graph/day_cell.vue";
import {SP_Drawer_status, SP_Drawer_user, SP_Start} from "@/store/planner/SelectedPeriodStore";
import {AllPeriods} from "@/store/planner/PeriodsStore";

export default {
  name: "ScheduleEditor",
  components: { DayCell },
  data() {
    return {
      drawer: false
    }
  },
  async beforeMount() {
    await this.update_editor()
  },
  watch: {
    async period_current() {
      await this.update_editor()
    },
    async period_size() {
      await this.update_editor()
    }
  },
  methods: {
    toggle_drawer: function (user) {
      this.drawer_user = user
      this.drawer_status = true
    },
    selectRow: function () {
      if (!this.period_start) {
        event.target.style.background = '#ececec'
      }
    },
    deselectRow: function () {
      event.target.style.background = 'none'
    },
    update_editor: async function () {
      this.generate_calendar()
      await this.get_planner_periods()
    },
    generate_calendar: function () {

    },
    get_planner_periods: async function () {
      let data = JSON.stringify({
        date: this.period_current.format('YYYY-MM-DD[T]00:00:00'),
        size: this.period_size
      })
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetPlannerData`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: data
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log('Успешно!')
            let periods = JSON.parse(result)
            for (let district of periods) {
              district.users = district.users.sort(function (x, y) {
                if (x.user_name < y.user_name) return -1;
                if (x.user_name > y.user_name) return 1;
                return 0;
              })
            }
            this.periods = periods
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    }
  },
  computed: {
    drawer_status: {
      get() {
        return SP_Drawer_status().get()
      },
      set(value) {
        SP_Drawer_status().set(value)
      }
    },
    drawer_user: {
      get() {
        return SP_Drawer_user().get()
      },
      set(value) {
        SP_Drawer_user().set(value)
      }
    },
    current_tool: {
      get() {
        return Current().get()
      },
      set(value) {
        Current().set(value)
      }
    },
    periods: {
      get() {
        return AllPeriods().get()
      },
      set(value) {
        AllPeriods().set(value)
      }
    },
    period_start: {
      get() {
        return SP_Start().get()
      },
      set(value) {
        SP_Start().set(value)
      }
    },
    calendar() {
      let calendar = {
        period: {
          length: 0
        },
        months: []
      }
      for (let i = 0; i < this.period_size; i++) {
        let month = moment(this.period_current).add(i, 'month')
        calendar.months.push({
          year: month.format('YYYY'),
          name: month.format('MMMM'),
          id: month.format('MM'),
          length: month.endOf('month').format('D')
        })

        calendar.period.length += parseInt(month.endOf('month').format('D'))
      }
      return calendar
    },
    current: {
      get() {
        return Current().get()
      },
      set(value) {
        Current().set(value)
      }
    },
    deletion: {
      get() {
        return Deletion().get()
      },
      set(value) {
        Deletion().set(value)
      }
    },
    period_current: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    },
    period_size: {
      get() {
        return PeriodSize().get()
      },
      set(value) {
        PeriodSize().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>

<style scoped lang="scss">
.calendar-date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  background-color: #6c8693;
  color: #f0f3f4;
  width: 20px;
  font-size: 8px;
  aspect-ratio: 1 / 1;
}
</style>